export const detailUrl = ({ id }) => `/other-contracts/detail/${id}/invoicing`;

export const invoicingToContractDetailUrl = ({ id }) =>
  `/error-redirect/invoicingother/${id}`;
